export default __webpack_public_path__ + "img/TourStep5-3e4333fc0c19b99b5b2d21f04663afe8.png";